package diana.soleil.design.iraniancanadienbazzar.feature.chat

import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

/** Koin bindings for the chat feature. Aggregated by the app composition root (`:shared`). */
val chatModule = module {
    viewModel { InboxViewModel(get(), get(), get(), get(), get()) }
    viewModel { NewMessageViewModel(get()) }
    viewModel { PeopleViewModel(get(), get(), get()) }
    viewModel { (uid: String) -> PersonProfileViewModel(uid, get()) }
    viewModel { (businessId: String) -> ChannelViewModel(businessId, get(), get(), get()) }
    viewModel { (conversationId: String?, businessId: String?) ->
        ConversationViewModel(get(), get(), get(), get(), get(), get(), conversationId, businessId)
    }
}
